<template>
  <a-form-item label="送签产品" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:90px' }">
    <!-- <a-button class="app-btn info-btn" @click="addRow" v-if="!isView">
      <app-icon type="icon-tianjia"></app-icon>
      添加送签产品
    </a-button> -->

    <!-- <span style="margin-left: 20px">
      渠道：
      <a-select
        class="form-control sm"
        v-model="channelId"
        placeholder="请选择"
        allowClear
        :options="channelIdList"
      ></a-select>
    </span> -->

    <span style="margin-left: 20px">
      产品名称：
      <a-input style="width: 200px" v-model="productName" placeholder="请输入供应商名称"></a-input>
    </span>

    <span>
      <a-button style="margin-left: 20px" class="app-btn" type="default" @click="resetAndQuery">重置搜索</a-button>
      <a-button style="margin-left: 20px" class="app-btn" type="primary" @click="handleSearch">立即搜索</a-button>
    </span>

    <a-table
      style="margin-top: 20px"
      class="queryView-table"
      :rowKey="useRowIndex"
      bordered
      :columns="tableColumns"
      :dataSource="dataSource"
      :pagination="false"
      size="middle"
    ></a-table>

    <AddPro ref="addPro"></AddPro>
    <SetPrice ref="setPrice"></SetPrice>
    <SetAddress ref="setAddress"></SetAddress>
    <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk" :width="580">
      <div class="auth-modal">
        <div class="auth-container" ref="html2canvasContainer">
          <div class="auth-company">{{ modal.data.supplierCompanyName }}</div>
          <div class="auth-img">
            <auto-img :src="require('@/assets/images/authorization.png')" style="width: 100%; height: 100%"></auto-img>
          </div>
          <div class="auth-product">{{ modal.data.productName }}</div>
          <div class="auth-time">{{ modal.data.cooperateStartDate }} - {{ modal.data.cooperateEndDate }}</div>
          <div class="auth-rqCode">
            <auto-img :src="modal.data.rqCode" style="width: 100%; height: 100%"></auto-img>
          </div>
        </div>
        <div class="auth-loading" v-if="modal.data.loading">
          <a-spin></a-spin>
        </div>
        <auto-img class="auth-result-img" :src="modal.data.authorizeUrl" v-if="modal.data.authorizeUrl"></auto-img>
      </div>
      <template #footer>
        <a-button type="primary" @click="download(modal.data.authorizeUrl)" :disabled="modal.data.loading">
          下载授权书
        </a-button>
      </template>
    </a-modal>
  </a-form-item>
</template>

<script>
import { webUpload } from '@/service/oss'
import { dataURLtoFile } from '@/utils/file'
import { loadImage } from '@/utils/loadScript'
import { toolMixin } from '@/utils/mixin'
import html2canvas from 'html2canvas'
import fileDownload from 'js-file-download'
import AddPro from './AddVisaPro.vue'
import SetAddress from './SetAddress.vue'
import SetPrice from './SetVisaPrice.vue'
export default {
  mixins: [toolMixin],
  props: {
    isView: {
      type: Boolean,
      default: true,
    },
    companyData: {
      type: Object,
      require: true,
    },
  },
  components: {
    AddPro,
    SetPrice,
    SetAddress,
  },
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        customRender: (text, row, index) => {
          return <div>{index + 1}</div>
        },
      },
      {
        title: '产品名称',
        width: '150px',
        align: 'center',
        dataIndex: 'productName',
      },
      // {
      //   title: '渠道',
      //   width: '100px',
      //   align: 'center',
      //   dataIndex: 'channelName',
      //   customRender: (text, row) => {
      //     return <div>{text || row.channelId}</div>
      //   },
      // },
      {
        title: '领区',
        width: '80px',
        align: 'center',
        dataIndex: 'area',
      },
      {
        title: '销售价格',
        width: '80px',
        align: 'center',
        dataIndex: 'sellingPrice',
      },
      {
        title: '供应商加价金额',
        width: '80px',
        align: 'center',
        dataIndex: 'addSupplierPrice',
      },
      // {
      //   title: '签证结算价',
      //   width: '80px',
      //   align: 'center',
      //   dataIndex: 'visaSettlementPrice',
      // },
      // {
      //   title: '打印服务费',
      //   width: '80px',
      //   align: 'center',
      //   dataIndex: 'printPrice',
      // },
      // {
      //   title: '打印结算价',
      //   width: '80px',
      //   align: 'center',
      //   dataIndex: 'printSettlementPrice',
      // },
      // {
      //   title: '单程快递费',
      //   width: '80px',
      //   align: 'center',
      //   dataIndex: 'expressPrice',
      // },
      // {
      //   title: '地址已验证',
      //   width: '8%',
      //   align: 'center',
      //   dataIndex: 'isVerify',
      //   customRender: (text) => {
      //     return <div>{this.translateType$t(text, 'isVerify')}</div>
      //   },
      // },
      // {
      //   title: '操作',
      //   width: '20%',
      //   align: 'center',
      //   customRender: (text, row, index) => {
      //     if (this.isView) {
      //       return null
      //     }
      //     return (
      //       <div class="flex gap-4 justify-center items-center text-primary-500">
      //         <a
      //           onClick={() => {
      //             this.setPrice(row)
      //           }}
      //         >
      //           设置结算价
      //         </a>
      //         {/* <a
      //           onClick={() => {
      //             this.setAddress(row)
      //           }}
      //         >
      //           设置收件地址
      //         </a> */}
      //         <a
      //           onClick={() => {
      //             this.showAuthorzation(row)
      //           }}
      //         >
      //           查看授权书
      //         </a>
      //         <app-icon
      //           type="icon-shanchu"
      //           onClick={() => {
      //             this.removeRow(row)
      //           }}
      //         ></app-icon>
      //       </div>
      //     )
      //   },
      // },
    ]
    return {
      tableColumns,
      dataSource: [],
      selectedRowKeys: [],
      modal: {
        visible: false,
        title: '',
        data: {},
      },

      // channelIdList: [],
      productName: '',
      // channelId: '',
    }
  },
  mounted() {
    this.loadList()
    // this.getChannelList()
  },
  computed: {
    typesMap() {
      return {
        isVerify: [
          { value: 0, label: '未验证' },
          { value: 1, label: '已验证' },
        ],
      }
    },
  },
  methods: {
    // async getChannelList() {
    //   const res = await this.$axios.get('/channel/admin/channel/getChannelList', {
    //     params: {
    //       page: 0,
    //       limit: -1,
    //     },
    //   })
    //   if (res.success) {
    //     this.channelIdList = res.data.map((item) => {
    //       return {
    //         value: item.channelId,
    //         label: item.channelName,
    //       }
    //     })
    //     this.channelIdList.unshift({
    //       value: '0',
    //       label: '兔兔平台',
    //     })
    //   }
    // },
    async addRow() {
      const list = await this.$refs.addPro.start()
      const data = list.map((row) => {
        return {
          supplierCompanyId: this.companyData.companyId,
          supplierCompanyName: this.companyData.companyName,
          productId: row.productId,
        }
      })
      await this.$axios.post('/product-web-api/admin/product/addTransfer', {
        data,
      })
      this.$message.success('操作成功')
      this.loadList()
    },
    async removeRow(row) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      await this.$axios.get('/product-web-api/admin/product/deleteTransferByProductId', {
        params: {
          productId: row.productId,
        },
      })
      this.$message.success('操作成功!')
      this.loadList()
    },
    async setPrice(row) {
      await this.$refs.setPrice.start(row)
      this.loadList()
    },
    async setAddress(row) {
      const obj = this.dataSource.find((v) => v.address && v.city && v.phoneNumber)
      const data = await this.$refs.setAddress.start(row, obj)
      await this.$axios.post('/product-web-api/admin/product/setTransferAddress', {
        data: data,
      })
      this.loadList()
    },
    async showAuthorzation(row) {
      this.resetModal$t()
      const res = await this.$axios.post('/product-web-api/admin/productTransefer/queryAuthorizeByProductId', {
        data: {
          productId: row.productId,
        },
      })

      this.modal.title = '查看授权书'
      this.modal.visible = true
      this.modal.data = {
        ...res.data,
        loading: false,
      }
      if (!this.modal.data.authorizeUrl) {
        this.modal.data.loading = true
        await loadImage([require('@/assets/images/authorization.png'), this.modal.data.rqCode])
        const src = await this.createAuthImg()
        await this.updateAuthImg(row.productId, src)
        this.modal.data.loading = false
      }
    },
    async createAuthImg() {
      await new Promise((resolve) => {
        setTimeout(resolve, 1000)
      })
      return html2canvas(this.$refs.html2canvasContainer, {
        backgroundColor: null,
        useCORS: true,
      })
        .then((canvas) => {
          const src = canvas.toDataURL('image/png')
          return Promise.resolve(src)
        })
        .catch((e) => {
          console.info('html2canvas error')
          console.error(e)
        })
    },
    async updateAuthImg(productId, dataurl) {
      const file = dataURLtoFile('authorization.png', dataurl)
      const authorizeUrl = await webUpload(file)
      await this.$axios.post('/product-web-api/admin/productTransefer/setAuthorizeUrlReqDto', {
        data: {
          productId,
          authorizeUrl: authorizeUrl.data,
        },
      })
    },
    handleOk() {},
    async loadList() {
      const companyId = this.companyData.companyId
      // const res = await this.$axios.get('/product-web-api/admin/product/queryTransferListByCompanyId', {
      //   params: {
      //     companyId,
      //     channelId: this.channelId,
      //     productName: this.productName,
      //   },
      // })
      const res = await this.$axios.get('/company/admin/product/supplier/getProxyProductList', {
        params: {
          companyId,
          // channelId: this.channelId,
          productType: 1,
          productName: this.productName,
        },
      })
      this.dataSource = res.data
    },
    async download(sourceSrc) {
      const fileName = sourceSrc.replace(/(.*\/)*([^.]+)/gi, '$2').replace(/\?.+/, '')
      try {
        const serverRes = await this.$axios.get(sourceSrc, {
          responseType: 'blob',
          interceptors: {
            response: false,
          },
        })
        fileDownload(serverRes.data, fileName)
      } catch (e) {
        window.open(sourceSrc)
      }
    },
    handleSearch() {
      this.loadList()
    },
    resetAndQuery() {
      // this.channelId = ''
      this.productName = ''
      this.loadList()
    },
  },
}
</script>

<style lang="less" scoped>
.auth-modal {
  position: relative;

  .auth-container {
    width: 530px;
    height: 725px;
    position: relative;
    box-sizing: content-box;

    .auth-img {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }

    .auth-company {
      position: absolute;
      top: 225px;
      z-index: 10;
      text-align: center;
      left: 0;
      right: 0;
      font-size: 18px;
      font-weight: bold;
    }

    .auth-product {
      position: absolute;
      z-index: 10;
      top: 310px;
      left: 0;
      right: 0;
      text-align: center;
    }

    .auth-time {
      position: absolute;
      z-index: 10;
      top: 362px;
      left: 150px;
    }

    .auth-rqCode {
      position: absolute;
      z-index: 10;

      top: 480px;
      width: 150px;
      left: 190px;
      height: 150px;
    }
  }

  .auth-loading {
    position: absolute;
    z-index: 100;
    background: #fff;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .auth-result-img {
    position: absolute;
    z-index: 100;
    background: #fff;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
